const ITEMS = ["HOT RODS", "WOF", "SERVICING & REPAIRS", "TYRE ALIGNMENT", "LIGHT ENGINEERING", "MARINE", "RETAIL SHOP"];

export const Marquee = () => (
  <div data-testid="services-marquee" className="overflow-hidden border-y border-white/10 bg-[#111] py-4">
    <div className="flex whitespace-nowrap animate-marquee w-max">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex">
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="font-display text-2xl tracking-widest text-gray-500 mx-6 flex items-center gap-6">
              {item} <span className="text-ember text-lg">///</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
